import { Injectable, } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BaseApiService } from './../../services/base-api.service';
import { SupplierOrderListModel } from './../models/supplier-order-list.model';
import { SupplierOrderLineModel } from './../models/supplier-order-line.model';
import { SupplierOrderModel } from './../models/supplier-order.model';
import { SupplierOrderPalletModel } from './../models/supplier-order-pallet.model';
import { SupplierOrderFilterModel } from './../models/supplier-order-filter.model';


@Injectable()
export class SupplierOrderService extends BaseApiService {

    getOrders(filter: SupplierOrderFilterModel): Observable<SupplierOrderListModel[]> {
        if (!filter.isSet()) {
            return Observable.of(null);
        }
        let q = '_';
        if (filter.supplier) {
            q += `&supplierNo=${encodeURIComponent(filter.supplier.id + '')}`
        }
        if (filter.orderNo) {
            q += `&orderNo=${encodeURIComponent(filter.orderNo)}`
        }
        if (filter.orderStatus && filter.orderStatus.label !== 'All') {
            q += `&orderState=${encodeURIComponent(filter.orderStatus.label)}`
        }
        if (filter.orderContract) {
            q += `&orderContract=${encodeURIComponent(filter.orderContract)}`
        }
        return this.get<SupplierOrderListModel[]>(`/api/suppliers/orders?${q}`);
    }

    getOrder(orderId: any): Observable<SupplierOrderModel> {
        if (!orderId) {
            return Observable.of(null);
        }

        // return Observable.of({
        //     orderNo: 123,
        //     authCode: '11',
        //     supplierNo: 'sup00',
        //     date: new Date(),
        //     status: 'Active',
        //     wantedDate: new Date(),
        //     lines: [{
        //         ifsId: '1',
        //         orderNo: 123,
        //         partNo: 122,
        //         description: 'line descr',
        //         plannedDate: new Date(),
        //         qty: 55,
        //         stdQty: 66, // amount per pallet
        //         units: 'm',
        //         status: 'New',
        //         printed: 'false'
        //     }]});

        return this.get<SupplierOrderModel>(`/api/suppliers/orders/${encodeURIComponent(orderId)}`)
            .map(data => {
                if (!data || !data[0]) {
                    return null;
                }
                const order = <SupplierOrderModel>data[0][0];
                order.lines = <SupplierOrderLineModel[]>data[1];
                return order;
            });
    }

    getPallets(lineIfsId: string): Observable<SupplierOrderPalletModel[]> {
        if (!lineIfsId) {
            return Observable.of(null);
        }
        // return Observable.of([
        //     {
        //         id: 444,
        //         lineIfsId: '456',
        //         qty: '88',
        //         printQty: '99'
        //     }
        // ]);
        return this.get<SupplierOrderPalletModel[]>(`/api/suppliers/pallets?id=${encodeURIComponent(lineIfsId)}`);
    }

    generatePallets(orderNo: number, lineIfsId: string, qty: number, qtyPerPallet: number): Observable<number> {
        if (!lineIfsId) {
            return Observable.of(null);
        }
        return this.post<number>(`/api/suppliers/pallets/generate`,
            { orderNo: orderNo, lineIfsId: lineIfsId, qty: qty, qtyPerPallet: qtyPerPallet });
    }

    addPallet(lineIfsId: string, qty: number): Observable<number> {
        if (!lineIfsId) {
            return Observable.of(null);
        }
        return this.post<number>(`/api/suppliers/pallets`, { lineIfsId: lineIfsId, qty: qty });
    }


}



// WEBPACK FOOTER //
// ./src/app/suppliers-barcodes/services/supplier-order.service.ts